export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";